export default {
  error_messages: {
    orders_disabled: 'Ordini qui al momento non disponibili',
  },
};
